// extracted by mini-css-extract-plugin
export default {"videoMain":"Video_videoMain__ZHefb","videoHolder":"Video_videoHolder__OPuIk","gapForVideo":"Video_gapForVideo__CWr+-"};